import { Field, FieldProps } from 'formik'
import * as React from 'react'
import { IFormValues } from './AddMobilityOptionCreateForm'

const Checkbox = (props: { name: string; value: boolean; displayName: string }) => {
  const handleChange = (field: any, form: any) => () => {
    form.setFieldValue(props.name, !field.value)
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<IFormValues>) => (
        <div className='mt2 flex justify-between'>
          <label htmlFor={field.name + '-' + props.value} className='font-small weight-300 font-grey3'>
            {props.displayName}
          </label>
          <input type='checkbox' {...field} onChange={handleChange(field, form)} />
        </div>
      )}
    </Field>
  )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/mobility-options/AddMobilityOptionCreateForm/Checkbox.tsx